import { render, staticRenderFns } from "./basketcounter.vue?vue&type=template&id=2306bb17"
import script from "./basketcounter.vue?vue&type=script&lang=js"
export * from "./basketcounter.vue?vue&type=script&lang=js"
import style0 from "./basketcounter.vue?vue&type=style&index=0&id=2306bb17&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2306bb17')) {
      api.createRecord('2306bb17', component.options)
    } else {
      api.reload('2306bb17', component.options)
    }
    module.hot.accept("./basketcounter.vue?vue&type=template&id=2306bb17", function () {
      api.rerender('2306bb17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/siteheader/assets/frontend/components/basketcounter.vue"
export default component.exports